import {Trans, t} from '@lingui/macro'
import styled from 'styled-components'

import {Link, Text, tokens} from '@pleo-io/telescope'

import diamondSvg from 'images/icons/diamond.svg'

const Card = styled.div`
    background-color: ${tokens.shade100};
    border-radius: ${tokens.arc8};
    padding: ${tokens.spacing16} ${tokens.spacing20};
    cursor: pointer;
`

const Icon = styled.img`
    margin-bottom: ${tokens.spacing4};
    width: 24px;
`

const CashbackPromoCard = ({onCardClicked}: {onCardClicked: (text: string) => void}) => {
    const CASHBACK_MESSAGE = t`Get up to 1% cashback every time your team pays with Pleo`
    const onCardClick = () => onCardClicked(CASHBACK_MESSAGE)

    return (
        <Card onClick={onCardClick} data-testid="cashback-promo-card">
            <Icon src={diamondSvg} alt={t`Diamond icon`} />
            <Text as="p" variant="small-subtle" color="shade800" space={4}>
                {CASHBACK_MESSAGE}
            </Text>
            <Link onClick={onCardClick} data-testid="cashback-learn-more-button">
                <Trans>Learn more</Trans>
            </Link>
        </Card>
    )
}
export default CashbackPromoCard
